// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"428":"97304184","440":"7a5f1ac3","791":"bf882e08"}[chunkId] + ".js";
};